
<template>
  <h1
    v-if='titulo.length > 0'
    class="titulo"
  >
    {{titulo}}
  </h1>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'Titulo',
  data () {
    return {
      titulo: '',
    }
  },
  apollo: {
    settings: {
      query: gql`
      query MyQuery {
        settings: settings(where:{key:{_eq:"Titulo_Live"}}){
          value
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.settings.length > 0) {
            this.titulo = data.settings[0].value
            console.log(data.settings[0].value)
          }
        }
      },
    },
  },
  mounted () {
    setInterval(() => {
      if (Object.keys(this.$apollo.queries).includes('settings')) {
        this.$apollo.queries.settings.refetch()
      }
    }, 5000)
  },
}
</script>

<style scoped>
.titulo {
  text-align: left;
  padding-left: 160px;
  padding-top: 55px;
  color: #ffffff;
  font-size: 52px;
  font-family: "Menlo", monospace;
}
</style>
